import { BASE_URL } from "@/services/api/base";

export const getInboxEndpoint = `${BASE_URL}/Inbox/Get`;
export const getTrackingEndpoint = `${BASE_URL}/Tracking/GetTracking`;
